const Cure = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                {
    /* Mobile Layout (sm:flex) */
  }
                <div className="mx-auto max-w-7xl lg:hidden">
                    <div className="flex flex-col gap-8">
                        {
    /* Header */
  }
                        <div>
                            <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                                Prozess der Reinigung und Regeneration
                            </p>
                            <h2 className="mt-5 font-serif text-2xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-3xl">
                                Persönliches Panchakarma für jeden Einzelnen
                            </h2>
                        </div>

                        {
    /* Image */
  }
                        <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] bg-transparent shadow-none">
                            <img
    src="/images/Hiru/public_images/DSC09223-Enhanced-NR-Edit-copy.webp"
    alt="Ayurveda-Behandlung im Rahmen von Panchakarma"
    className="h-full w-full object-contain object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        </div>

                        {
    /* Content */
  }
                        <div className="space-y-6 font-mulish text-base leading-8 text-gray-700">
                            <p>
                                Der eigentliche Panchakarma-Prozess beginnt mit der wichtigen Vorbereitung durch Snehana (Öltherapie) und Swedana (Schweißtherapie), zwei zentralen Elementen der Ayurveda-Heilkunde. Diese Maßnahmen helfen dabei, das gestörte Gleichgewicht der drei Doshas wiederherzustellen und den Körper so auf die eigentliche Reinigungstherapie vorzubereiten.
                            </p>
                            <p>
                                Sobald der Körper ausreichend entspannt ist, werden angesammelte Abfallstoffe ausgeschieden, die Doshas neu ausbalanciert und die Regeneration aus den tieferen Schichten des Körpers gestärkt.
                            </p>
                            <p>
                                Je nach Gesundheitszustand wird eine Behandlungsdauer von mehr als 21 Tagen empfohlen, mindestens jedoch 14 Tage, um die volle Wirkung von Panchakarma zu entfalten. Wenn Sie nur kurzfristig bleiben, wird Ihnen der Arzt im ersten Beratungsgespräch gern die passende Vorgehensweise und die bestmögliche Therapie für diesen Zeitraum empfehlen, damit Sie sich völlig entspannen können.
                            </p>
                        </div>
                    </div>
                </div>

                {
    /* Desktop Layout (hidden on sm, visible on lg) */
  }
                <div className="mx-auto hidden max-w-7xl items-start gap-10 lg:grid lg:grid-cols-[1.08fr_0.92fr] lg:gap-16">
                    <div className="order-1">
                        <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                            Prozess der Reinigung und Regeneration
                        </p>
                        <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Persönliches Panchakarma für jeden Einzelnen
                        </h2>

                        <div className="mt-8 space-y-6 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                            <p>
                                Der eigentliche Panchakarma-Prozess beginnt mit der wichtigen Vorbereitung durch Snehana (Öltherapie) und Swedana (Schweißtherapie), zwei zentralen Elementen der Ayurveda-Heilkunde. Diese Maßnahmen helfen dabei, das gestörte Gleichgewicht der drei Doshas wiederherzustellen und den Körper so auf die eigentliche Reinigungstherapie vorzubereiten.
                            </p>
                            <p>
                                Sobald der Körper ausreichend entspannt ist, werden angesammelte Abfallstoffe ausgeschieden, die Doshas neu ausbalanciert und die Regeneration aus den tieferen Schichten des Körpers gestärkt.
                            </p>
                            <p>
                                Je nach Gesundheitszustand wird eine Behandlungsdauer von mehr als 21 Tagen empfohlen, mindestens jedoch 14 Tage, um die volle Wirkung von Panchakarma zu entfalten. Wenn Sie nur kurzfristig bleiben, wird Ihnen der Arzt im ersten Beratungsgespräch gern die passende Vorgehensweise und die bestmögliche Therapie für diesen Zeitraum empfehlen, damit Sie sich völlig entspannen können.
                            </p>
                        </div>
                    </div>

                    <div className="order-2 lg:sticky lg:top-28">
                        <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] bg-transparent shadow-none">
                            <img
    src="/images/Hiru/public_images/DSC09223-Enhanced-NR-Edit-copy.webp"
    alt="Ayurveda-Behandlung im Rahmen von Panchakarma"
    className="h-full w-full object-contain object-center" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default Cure;
